import { useQuery } from 'react-query';
import { CUSTOMERS_TABLE_LOOKUP } from 'shared/constants/app';
import { useService } from 'shared/providers';
import { CustomerLookup } from 'shared/types';
import { CustomerFilter } from 'shared/types/customerManagement';

export function useQueryCustomerLookupWithFilters(filters?: CustomerFilter) {
  const { customerService } = useService();
  const { data, isLoading, isFetching, refetch } = useQuery<CustomerLookup[], Error>(
    [CUSTOMERS_TABLE_LOOKUP],
    () => customerService.getCustomersLookupWithFilters(filters),
    {
      onSuccess: data => {},
      retry: false,
    }
  );

  return { customers: data, isLoading, isFetching, refetch } as const;
}
